import { useEffect } from "react";

const useNoIndex = () => {
  useEffect(() => {
    const existingMetaTag = document.querySelector('meta[name="robots"]');
    existingMetaTag.content = "noindex";
    return () => {
      existingMetaTag.content = "index, follow";
    };
  }, []);
};

export default useNoIndex;